import { styled } from '../../Utilities';
import { getStyles } from './Shimmer.styles';
import { ShimmerBase } from './Shimmer.base';
export var Shimmer = styled(ShimmerBase, getStyles, undefined, {
  scope: 'Shimmer'
});